import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert, Card } from "react-bootstrap";
import moment from "moment";
import { API_URL } from "../..";
import Swal from "sweetalert2";

const EditAttendanceModal = ({ record, onClose, onUpdated, employee }) => {
 
  const [punchIn, setPunchIn] = useState(record.punch_in_time || "");
  const [punchOut, setPunchOut] = useState(record.punch_out_time || "");
  const [status, setStatus] = useState(
    record.status === "on-time" || record.status === "early"
      ? "on-time"
      : record.status === "late"
      ? "late"
      : "absent"
  );
  const [approvedHours, setApprovedHours] = useState(record.approved_hours || "");
  const [deduction_amount , setDeductionAmount] = useState(record.deduction_amount || 0)

  // Extract overtime data
  const overtime = record.attendanceOvertimes?.[0];
  const hasOvertime = overtime && overtime.status === "approved";

  const isFixed = hasOvertime && overtime.fixed_overtime_amount != null;
  const isHourly = hasOvertime && overtime.overtime_rate_per_hour != null;

  const formatTime = (time) => (time ? moment(time, "HH:mm:ss").format("hh:mm A") : "--");
  const formatDuration = (duration) => duration || "--";

  const handleSave = async () => {
    // if(status !== 'absent'){
      try {
        const payload = {
          user_id: record.user_id || employee,
          date: record.date || record.attendance_date,
          punch_in: punchIn.includes(":") ? punchIn + (punchIn.split(":").length === 2 ? ":00" : "") : punchIn + ":00",
          punch_out: punchOut.includes(":") ? punchOut + (punchOut.split(":").length === 2 ? ":00" : "") : punchOut + ":00",
          status,
          approved_hours: approvedHours,
          deduction_amount:deduction_amount,
        };
  
        const url = record.id
          ? `${API_URL}/api/attendance/timesheet-log/update/${record.id}`
          : `${API_URL}/api/attendance/admin-create`;
  
        const res = await fetch(url, {
          method: record.id ? "PUT" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const json = await res.json();
  
        if (json.success) {
          onUpdated(json.data);
          onClose();
        } else {
          alert(json.message || "Failed to save");
        }
      } catch (e) {
        console.error("Save error:", e);
        alert("Error saving attendance");
      }

    // }else{
    //      Swal.fire({
    //       title:'Failed to submit',
    //       text:'You are not able to mark the attendance when status is absent',
    //       icon:'error'

    //      })
    // }
  };

  return (
    <Modal show onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <span style={{ fontSize: 20 }}>Edit Attendance</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="text"
              value={moment(record.attendance_date || record.date).format("DD MMM YYYY")}
              readOnly
            />
          </Form.Group>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Punch In</Form.Label>
                <Form.Control
                  type="time"
                  value={punchIn}
                  onChange={(e) => setPunchIn(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Punch Out</Form.Label>
                <Form.Control
                  type="time"
                  value={punchOut}
                  onChange={(e) => setPunchOut(e.target.value)}
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="on-time">Present (On Time)</option>
                  <option value="late">Late</option>
                  <option value="absent">Absent</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Approved Hours</Form.Label>
                <Form.Control
                  type="number"
                  step="0.1"
                  min="0"
                  value={approvedHours}
                  onChange={(e) => setApprovedHours(e.target.value)}
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
          
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Deduction Amount</Form.Label>
                <Form.Control
                  type="number"
                  step="0.1"
                  min="0"
                  value={deduction_amount}
                  onChange={(e) => setDeductionAmount(e.target.value)}
                />
              </Form.Group>
            </div>
          </div>
        </Form>

        {/* Overtime Pay Section - Only if approved overtime exists */}
        {hasOvertime && (
          <div className="mt-4">
            <Alert variant="success" className="mb-3">
              <strong>Overtime Pay Already Approved</strong>
            </Alert>

            <Card className="border-success">
              <Card.Header className="bg-success text-white">
                <strong>Overtime Details (Locked)</strong>
              </Card.Header>
              <Card.Body>
                {/* Type: Fixed or Hourly */}
                <div className="mb-3">
                  <Form.Check
                    type="radio"
                    label="Fixed Overtime Amount"
                    checked={isFixed}
                    readOnly
                    disabled
                  />
                  {isFixed && (
                    <div className="ms-4 mt-2 p-3 bg-light rounded border">
                      <strong>Amount: £{parseFloat(overtime.fixed_overtime_amount).toFixed(2)}</strong>
                    </div>
                  )}

                  <Form.Check
                    type="radio"
                    label="Hourly Rate Overtime"
                    checked={isHourly}
                    readOnly
                    disabled
                    className="mt-3"
                  />
                  {isHourly && (
                    <div className="ms-4 mt-2 p-3 bg-light rounded border">
                      <strong>Rate: £{parseFloat(overtime.overtime_rate_per_hour).toFixed(2)} / hour</strong>
                      <br />
                      <strong>Duration: {formatDuration(overtime.total_duration)}</strong>
                      <br />
                      <strong>Total: £{(parseFloat(overtime.overtime_rate_per_hour) * 
                        (parseFloat(overtime.total_duration?.split("h")[0] || 0) + 
                         (parseFloat(overtime.total_duration?.split("m")[0]?.split(" ")[1] || 0) / 60)
                      ).toFixed(2))}</strong>
                    </div>
                  )}
                </div>

                {/* Overtime Request Info */}
                <hr />
                <h6 className="text-primary mt-20">Original Overtime Request</h6>
                <div className="row small text-muted">
                  <div className="col-md-6">
                    <strong>Date:</strong> {moment(overtime.date).format("DD MMM YYYY")}
                  </div>
                  <div className="col-md-6">
                    <strong>Start:</strong> {formatTime(overtime.start_time)}
                  </div>
                  <div className="col-md-6">
                    <strong>End:</strong> {formatTime(overtime.end_time)}
                  </div>
                  <div className="col-md-6">
                    <strong>Duration:</strong> {formatDuration(overtime.total_duration)}
                  </div>
                  {overtime.description && (
                    <div className="col-12 mt-2">
                      <strong>Reason:</strong> {overtime.description}
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>

            <div className="alert alert-warning mt-3 small">
              <strong>Note:</strong> This overtime pay is already approved and <u>cannot be changed</u> from here.
            </div>
          </div>
        )}

        {!hasOvertime && record.status !== "absent" && (
          <Alert variant="light" className="mt-3 border">
            No overtime pay applied for this day.
          </Alert>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
;

export default EditAttendanceModal;